const initialState = {
    categories: [],
    isReadingCategories: false
};

export default initialState;
